import { render, staticRenderFns } from "./Agent.vue?vue&type=template&id=f35b824a&"
import script from "./Agent.vue?vue&type=script&lang=js&"
export * from "./Agent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports